import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { Table, TableHeader, TableRow, TableHeading, TableBody, InputText } from '@insurancemenu/imenu-components-lib';
import { toJS } from 'mobx';
import ActionModal from 'components/common/modals/ActionModal';
import { ModalType } from 'global/utils/ModalsHelper';
import FormModal from 'components/common/modals/FormModal';
import { createStyles } from './styles';
import FavoriteProposalsRow from './FavoriteProposalsRow';

const FavoriteProposalsTable = observer((): JSX.Element => {
  const {
    favoriteProposalsStore: {
      loading,
      renameLoading,
      filter,
      carts,
      isWarningModalOpen,
      isSaveModalOpen,
      currentCartId,
      saveForm,
      getCartsByRateSegment,
      closeWarningModal,
      closeRenameTemplateModal,
      renameProposal,
      deleteCart,
    },
  } = useRootStore();

  const convertedCarts = carts.map((cart) => toJS(cart)).slice();

  useEffect(() => {
    void getCartsByRateSegment(filter);
  }, [filter]);

  const rowsList = convertedCarts.map((cart) => <FavoriteProposalsRow key={cart.id} cart={cart} />);

  const classes = createStyles(convertedCarts.length);
  const removedTemplateName = convertedCarts.find(({ id }) => id === currentCartId)?.cartName || 'this';

  const onRemoveTemplate = (): void => {
    void deleteCart();
    closeWarningModal();
  };

  const onRenameTemplate = async (): Promise<void> => {
    await renameProposal();
    closeRenameTemplateModal();
    void getCartsByRateSegment(filter);
  };

  const FormContent = (
    <InputText
      label=""
      name="name"
      value={saveForm.fields.name.value}
      onChange={saveForm.onFieldChange}
      width="30rem"
      className={classes.templateInputName}
      validationPassed={!saveForm.fields.name.unpassedValidationMsg}
      validationMessage={saveForm.fields.name.unpassedValidationMsg || ''}
    />
  );

  return (
    <div className={classes.content}>
      <div className={classes.tableWrapper}>
        <Table loading={loading} totalElements={convertedCarts.length}>
          <TableHeader className={classes.tableHeader}>
            <TableRow>
              <TableHeading className={classes.tableHeading}>Template Name</TableHeading>
              <TableHeading className={classes.tableHeading}>Rate Segment</TableHeading>
              <TableHeading className={classes.tableHeading}>Date of Creation</TableHeading>
              <TableHeading className={classes.tableHeading}>Product Lines</TableHeading>
              <TableHeading className={classes.tableHeading} />
            </TableRow>
          </TableHeader>
          <TableBody>{rowsList}</TableBody>
        </Table>
        <ActionModal
          show={isWarningModalOpen}
          title="Delete Proposal Template"
          subtitle={
            <p>
              You are about to delete
              <b className={classes.templateName}>{removedTemplateName}</b>
              template.You will no longer be able to create proposals based on this template.
            </p>
          }
          actionButtonText="Delete Template"
          closeButtonText="Cancel"
          onClose={closeWarningModal}
          onAction={onRemoveTemplate}
          modalType={ModalType.DELETE}
        />
        <FormModal
          show={isSaveModalOpen}
          title="Rename Template"
          subtitle="Please input the name you want to save the proposal with."
          formContent={FormContent}
          showCloseButton={false}
          onClose={closeRenameTemplateModal}
          onSubmit={onRenameTemplate}
          modalType={ModalType.CREATION}
          isFormValid={saveForm.isFormValid()}
          loading={renameLoading}
        />
      </div>
    </div>
  );
});

export default FavoriteProposalsTable;
